import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function format$default(obj, builder, minusNotRequired, $super) {
  minusNotRequired = minusNotRequired === VOID ? false : minusNotRequired;
  var tmp;
  if ($super === VOID) {
    this.x21(obj, builder, minusNotRequired);
    tmp = Unit_instance;
  } else {
    tmp = $super.x21.call(this, obj, builder, minusNotRequired);
  }
  return tmp;
}
var FormatterStructureClass;
function FormatterStructure() {
  if (FormatterStructureClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FormatterStructure');
    FormatterStructureClass = $;
  }
  return FormatterStructureClass;
}
var SpacePaddedFormatterClass;
function SpacePaddedFormatter() {
  if (SpacePaddedFormatterClass === VOID) {
    class $ {
      constructor(formatter, padding) {
        this.y21_1 = formatter;
        this.z21_1 = padding;
      }
      x21(obj, builder, minusNotRequired) {
        // Inline function 'kotlin.let' call
        var it = StringBuilder().d1();
        this.y21_1.x21(obj, it, minusNotRequired);
        var string = it.toString();
        // Inline function 'kotlin.repeat' call
        var times = this.z21_1 - string.length | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            builder.xb(_Char___init__impl__6a9atx(32));
          }
           while (inductionVariable < times);
        builder.e1(string);
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'SpacePaddedFormatter', VOID, VOID, [FormatterStructure()]);
    SpacePaddedFormatterClass = $;
  }
  return SpacePaddedFormatterClass;
}
var SignedFormatterClass;
function SignedFormatter() {
  if (SignedFormatterClass === VOID) {
    class $ {
      constructor(formatter, allSubFormatsNegative, alwaysOutputSign) {
        this.a22_1 = formatter;
        this.b22_1 = allSubFormatsNegative;
        this.c22_1 = alwaysOutputSign;
      }
      x21(obj, builder, minusNotRequired) {
        var tmp;
        if (!minusNotRequired && this.b22_1(obj)) {
          tmp = _Char___init__impl__6a9atx(45);
        } else if (this.c22_1) {
          tmp = _Char___init__impl__6a9atx(43);
        } else {
          tmp = null;
        }
        var sign = tmp;
        var tmp_0 = sign;
        if ((tmp_0 == null ? null : new (Char())(tmp_0)) == null)
          null;
        else {
          var tmp_1 = sign;
          // Inline function 'kotlin.let' call
          var it = (tmp_1 == null ? null : new (Char())(tmp_1)).z2_1;
          builder.xb(it);
        }
        var tmp_2;
        if (minusNotRequired) {
          tmp_2 = true;
        } else {
          var tmp_3 = sign;
          tmp_2 = equals(tmp_3 == null ? null : new (Char())(tmp_3), new (Char())(_Char___init__impl__6a9atx(45)));
        }
        this.a22_1.x21(obj, builder, tmp_2);
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'SignedFormatter', VOID, VOID, [FormatterStructure()]);
    SignedFormatterClass = $;
  }
  return SignedFormatterClass;
}
var ConditionalFormatterClass;
function ConditionalFormatter() {
  if (ConditionalFormatterClass === VOID) {
    class $ {
      constructor(formatters) {
        this.d22_1 = formatters;
      }
      x21(obj, builder, minusNotRequired) {
        var tmp0_iterator = this.d22_1.m1();
        while (tmp0_iterator.n1()) {
          var tmp1_loop_parameter = tmp0_iterator.o1();
          var condition = tmp1_loop_parameter.cf();
          var formatter = tmp1_loop_parameter.df();
          if (condition(obj)) {
            formatter.x21(obj, builder, minusNotRequired);
            return Unit_instance;
          }
        }
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'ConditionalFormatter', VOID, VOID, [FormatterStructure()]);
    ConditionalFormatterClass = $;
  }
  return ConditionalFormatterClass;
}
var ConcatenatedFormatterClass;
function ConcatenatedFormatter() {
  if (ConcatenatedFormatterClass === VOID) {
    class $ {
      constructor(formatters) {
        this.e22_1 = formatters;
      }
      x21(obj, builder, minusNotRequired) {
        var tmp0_iterator = this.e22_1.m1();
        while (tmp0_iterator.n1()) {
          var formatter = tmp0_iterator.o1();
          formatter.x21(obj, builder, minusNotRequired);
        }
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'ConcatenatedFormatter', VOID, VOID, [FormatterStructure()]);
    ConcatenatedFormatterClass = $;
  }
  return ConcatenatedFormatterClass;
}
//region block: exports
export {
  format$default as format$default2wn8ht1tr5xi2,
  ConcatenatedFormatter as ConcatenatedFormattergumn65iplrh1,
  ConditionalFormatter as ConditionalFormatter2qfqdnibwbifo,
  FormatterStructure as FormatterStructure1ss012tmsg37r,
  SignedFormatter as SignedFormatter14cujr8xyyuqw,
  SpacePaddedFormatter as SpacePaddedFormatter1bbtqhbgrvf8v,
};
//endregion

//# sourceMappingURL=Formatter.mjs.map
